import apolloClient from '../../apolloClient';
import brandsMutation from 'src/gql/mutations/brand';

const createBrand = async (variables) =>
  apolloClient.mutate({
    mutation: brandsMutation.CREATE_BRAND,
    fetchPolicy: 'no-cache',
    variables,
  });

const updateBrandById = async (variables) =>
  apolloClient.mutate({
    mutation: brandsMutation.UPDATE_BRAND_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

const deleteBrandById = async (variables) =>
  apolloClient.mutate({
    mutation: brandsMutation.DELETE_BRAND_BY_ID,
    fetchPolicy: 'no-cache',
    variables,
  });

export default {
  createBrand,
  updateBrandById,
  deleteBrandById,
};
